import { render, staticRenderFns } from "./myDistribution.vue?vue&type=template&id=0b52348c"
import script from "./myDistribution.vue?vue&type=script&lang=js"
export * from "./myDistribution.vue?vue&type=script&lang=js"
import style0 from "./myDistribution.vue?vue&type=style&index=0&id=0b52348c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports